import {
  Building2,
  CreditCard,
  FileText,
  Package,
  Receipt,
  Truck,
} from "lucide-react";

import { WizardStepConfig, WizardStepId } from "./types";

export const wizardBasePath = "/wizard";

export const WIZARD_STEPS: WizardStepConfig[] = [
  {
    id: "company-information",
    urlSegment: "step-1",
    label: "Company",
    skippable: false,
    icon: Building2,
  },
  {
    id: "catalog",
    urlSegment: "step-2",
    label: "Catalog",
    skippable: true,
    icon: Package,
  },
  {
    id: "content-pages",
    urlSegment: "step-3",
    label: "Content",
    skippable: true,
    icon: FileText,
  },
  {
    id: "taxes",
    urlSegment: "step-4",
    label: "Taxes",
    skippable: true,
    icon: Receipt,
  },
  {
    id: "payment",
    urlSegment: "step-5",
    label: "Payment",
    skippable: true,
    icon: CreditCard,
  },
  {
    id: "shipping",
    urlSegment: "step-6",
    label: "Shipping",
    skippable: true,
    icon: Truck,
  },
];

export const SEGMENT_TO_STEP = new Map<string, WizardStepConfig>(
  WIZARD_STEPS.map(step => [step.urlSegment, step]),
);

export const ID_TO_STEP = new Map<WizardStepId, WizardStepConfig>(
  WIZARD_STEPS.map(step => [step.id, step]),
);

export const wizardStepPath = (segment: string) =>
  `${wizardBasePath}/${segment}`;

export const wizardStep1Path = wizardStepPath("step-1");

export const wizardEntryPath = wizardStep1Path;
